import { fork, all } from 'redux-saga/effects'
import { processSaga, watchSaga, chainSagas } from '../workflow'
import { getParamsForKitDraftSet, triggerUserProfileKitAdd, onDuplicateSuccess, selectKitOwnById, getParamsForKitSuggestionSet } from './sagas'
// eslint-disable-next-line import/no-named-as-default, temporary until we only export the one thing
import actionTypes from '../../actionTypes'
import actionWorkflows from '../../actionWorkflows'
import duplicateKitFromKitId from '../../../dataservices/duplicateKitFromKitId'
import getKitByKitId from '../../../dataservices/getKitByKitId'
import getPostsByKitId from '../../../dataservices/getPostsByKitId'
import deleteKitByKitId from '../../../dataservices/deleteKitByKitId'
import setKit from '../../../dataservices/setKit'
import setKitOwn from '../../../dataservices/setKitOwn'
import setKitWant from '../../../dataservices/setKitWant'
import getKitOwnWants from '../../../dataservices/getKitOwnWants'
import setKitSuggestion from '../../../dataservices/setKitSuggestion'
import deleteKitSuggestion from '../../../dataservices/deleteKitSuggestion'
import getKitSuggestionsByKitId from '../../../dataservices/getKitSuggestionsByKitId'

const kitFetchingActions = [
	actionTypes.kitFetch_Success,
	actionTypes.kitDraftFetch_Success,
	actionTypes.postDraftKitFetch_Success,
	actionTypes.userProfileKitsFetch_Success,
	actionTypes.userProfileKitsOwnedFetch_Success,
	actionTypes.userProfileKitsWantedFetch_Success,
	actionTypes.SEARCH_KIT_SUCCESS,
	actionTypes.feedFetch_Success,
	actionTypes.postFetch_Success,
	actionTypes.userProfilePostsFetch_Success
]

const kitDraftSetWorkflow = processSaga.bind(null, actionWorkflows.kitDraftSet, setKit)
const kitDuplicateWorkflow = processSaga.bind(null, actionWorkflows.kitDuplicate, duplicateKitFromKitId)
const kitFetchWorkflow = processSaga.bind(null, actionWorkflows.kitFetch, getKitByKitId)
const kitShareFetchWorkflow = processSaga.bind(null, actionWorkflows.kitShareFetch, getKitByKitId)
const kitDraftFetchWorkflow = processSaga.bind(null, actionWorkflows.kitDraftFetch, getKitByKitId)
const kitDeleteWorkflow = processSaga.bind(null, actionWorkflows.kitDelete, deleteKitByKitId)
const kitOwnSetWorkflow = processSaga.bind(null, actionWorkflows.kitOwnSet, setKitOwn)
const kitWantSetWorkflow = processSaga.bind(null, actionWorkflows.kitWantSet, setKitWant)
const kitPostsFetchWorkflow = processSaga.bind(null, actionWorkflows.kitPostsFetch, getPostsByKitId)
const kitOwnWantFetchWorkflow = processSaga.bind(null, actionWorkflows.kitOwnWantFetch, getKitOwnWants)
const kitSuggestionsFetchWorkflow = processSaga.bind(null, actionWorkflows.kitSuggestionsFetch, getKitSuggestionsByKitId)
const kitSuggestionSetWorkflow = processSaga.bind(null, actionWorkflows.kitSuggestionSet, setKitSuggestion)
const kitSuggestionDeleteWorkflow = processSaga.bind(null, actionWorkflows.kitSuggestionDelete, deleteKitSuggestion)

const kitDuplicateChain = chainSagas.bind(null, [kitDuplicateWorkflow, triggerUserProfileKitAdd, onDuplicateSuccess, kitFetchWorkflow])
const kitViewFetchChain = chainSagas.bind(null, [kitFetchWorkflow, kitPostsFetchWorkflow, kitSuggestionsFetchWorkflow])

export default function* root() {
	yield all([
		fork(watchSaga.bind(null, [actionTypes.kitDraftSet, actionTypes.kitDraftSetImageUrlAndKitId], kitDraftSetWorkflow, {
			latest: true,
			selectParams: getParamsForKitDraftSet
		})),
		fork(watchSaga.bind(null, actionTypes.kitDuplicate, kitDuplicateChain)),
		fork(watchSaga.bind(null, actionTypes.kitFetch, kitViewFetchChain)),
		fork(watchSaga.bind(null, actionTypes.kitDraftFetch, kitDraftFetchWorkflow, { latest: true })),
		fork(watchSaga.bind(null, actionTypes.kitDelete, kitDeleteWorkflow)),
		fork(watchSaga.bind(null, actionTypes.kitOwnSet, kitOwnSetWorkflow)),
		fork(watchSaga.bind(null, actionTypes.kitWantSet, kitWantSetWorkflow)),
		fork(watchSaga.bind(null, kitFetchingActions, kitOwnWantFetchWorkflow, { selectParams: selectKitOwnById })),
		fork(watchSaga.bind(null, actionTypes.kitSuggestionSet, kitSuggestionSetWorkflow, { latest: true, selectParams: getParamsForKitSuggestionSet })),
		fork(watchSaga.bind(null, actionTypes.kitSuggestionDelete, kitSuggestionDeleteWorkflow)),
		fork(watchSaga.bind(null, actionTypes.kitSuggestionsFetch, kitSuggestionsFetchWorkflow)),
		fork(watchSaga.bind(null, actionTypes.kitShareFetch, kitShareFetchWorkflow))
	])
}



// WEBPACK FOOTER //
// ./src/redux/saga/kits/index.js